var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
var getFileInfo = function (fileName) {
    var match = fileName.match(/\.(xlsx|csv|txt)$/i);
    return {
        ext: match ? match[1].toLowerCase() : "xlsx",
        baseName: fileName.replace(/\.(xlsx|csv|txt)$/i, "")
    };
};
export var downloadFile = function (_a) {
    var countryCode = _a.countryCode, fileName = _a.fileName, config = _a.config;
    if (!fileName || !countryCode || !config)
        return;
    var _b = getFileInfo(fileName), ext = _b.ext, baseName = _b.baseName;
    var columns = config.columns, rows = config.rows, withHeader = config.withHeader;
    // ✅ Fallback logic
    var selectedColumns = columns || (columns === null || columns === void 0 ? void 0 : columns.default) || [];
    var selectedRows = (rows === null || rows === void 0 ? void 0 : rows[countryCode]) || (rows === null || rows === void 0 ? void 0 : rows.default) || [];
    if (!selectedColumns.length) {
        console.warn("No columns found, file will be empty");
    }
    var phoneSeries = 1000000000; //10 digit
    if (countryCode == '237') {
        phoneSeries = 600000000;
    }
    // 🔹 Generate phone dynamically if column exists
    var processedRows = selectedRows.map(function (row, index) {
        if (selectedColumns.some(function (c) { return c.key === "phone"; })) {
            return __assign(__assign({}, row), { phone: "".concat(countryCode).concat(phoneSeries + index) });
        }
        if (selectedColumns.some(function (c) { return c.key === "countryCode"; })) {
            return __assign(__assign({}, row), { countryCode: "".concat(countryCode) });
        }
        return row;
    });
    /* =========================
       TXT ONLY (comma separated, no header)
       ========================= */
    if (ext === "txt") {
        var txtContent = processedRows
            .map(function (row) {
            return selectedColumns
                .map(function (col) { var _a; return (_a = row[col.key]) !== null && _a !== void 0 ? _a : ""; })
                .join(",");
        } // 👈 comma separated
        )
            .join("\n"); // 👈 new line per row
        saveAs(new Blob([txtContent], { type: "text/plain;charset=utf-8;" }), "".concat(baseName, ".txt"));
        return;
    }
    /* =========================
       EXISTING CSV / XLSX LOGIC
       ========================= */
    var worksheet;
    if (withHeader) {
        var data = processedRows.map(function (row) {
            return selectedColumns.reduce(function (acc, col) {
                var _a;
                acc[col.label] = (_a = row[col.key]) !== null && _a !== void 0 ? _a : "";
                return acc;
            }, {});
        });
        worksheet = XLSX.utils.json_to_sheet(data);
    }
    else {
        var aoaData = processedRows.map(function (row) {
            return selectedColumns.map(function (col) { var _a; return (_a = row[col.key]) !== null && _a !== void 0 ? _a : ""; });
        });
        worksheet = XLSX.utils.aoa_to_sheet(aoaData);
    }
    // 🔹 CSV (unchanged)
    if (ext === "csv") {
        var csv = XLSX.utils.sheet_to_csv(worksheet);
        saveAs(new Blob([csv], { type: "text/csv;charset=utf-8;" }), "".concat(baseName, ".csv"));
        return;
    }
    // 🔹 XLSX (unchanged)
    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");
    var excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });
    saveAs(new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }), "".concat(baseName, ".xlsx"));
};
export var downloadFileWithout_txt = function (_a) {
    var countryCode = _a.countryCode, fileName = _a.fileName, config = _a.config;
    if (!fileName || !countryCode || !config)
        return;
    var _b = getFileInfo(fileName), ext = _b.ext, baseName = _b.baseName;
    var columns = config.columns, rows = config.rows, withHeader = config.withHeader;
    // ✅ Fallback logic for BOTH columns & rows
    var selectedColumns = columns || (columns === null || columns === void 0 ? void 0 : columns.default) || [];
    var selectedRows = (rows === null || rows === void 0 ? void 0 : rows[countryCode]) || (rows === null || rows === void 0 ? void 0 : rows.default) || [];
    if (!selectedColumns.length) {
        console.warn("No columns found, file will be empty");
    }
    var phoneSeries = 1000000000; //10 digit
    if (countryCode == '237') {
        phoneSeries = 600000000;
    }
    // 🔹 Generate phone dynamically if column exists
    var processedRows = selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.map(function (row, index) {
        if (selectedColumns === null || selectedColumns === void 0 ? void 0 : selectedColumns.some(function (c) { return c.key === "phone"; })) {
            return __assign(__assign({}, row), { phone: "".concat(countryCode).concat(phoneSeries + index) });
        }
        return row;
    });
    var worksheet;
    if (withHeader) {
        // ✅ HEADER MODE
        var data = processedRows.map(function (row) {
            return selectedColumns.reduce(function (acc, col) {
                var _a;
                acc[col.label] = (_a = row[col.key]) !== null && _a !== void 0 ? _a : "";
                return acc;
            }, {});
        });
        worksheet = XLSX.utils.json_to_sheet(data);
    }
    else {
        // ✅ NO HEADER MODE
        var aoaData = processedRows.map(function (row) {
            return selectedColumns.map(function (col) { var _a; return (_a = row[col.key]) !== null && _a !== void 0 ? _a : ""; });
        });
        worksheet = XLSX.utils.aoa_to_sheet(aoaData);
    }
    // 🔹 CSV
    if (ext === "csv") {
        var csv = XLSX.utils.sheet_to_csv(worksheet);
        saveAs(new Blob([csv], { type: "text/csv;charset=utf-8;" }), "".concat(baseName, ".csv"));
        return;
    }
    // 🔹 XLSX
    var workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");
    var excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });
    saveAs(new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }), "".concat(baseName, ".xlsx"));
};
